import { Component, OnInit } from '@angular/core';
import { DialogConfig } from '../dialog/dialog-config';
import { SmartModalService } from '../../services/smart-modal.service';

@Component({
    selector: 'kx-convox-patient-mobile',
    templateUrl: './convox-patient-mobile.component.html',
    styleUrls: ['./convox-patient-mobile.component.scss'],
    standalone: false
})
export class ConvoxPatientMobileComponent implements OnInit {
  data: any;

  constructor(
    private dialogConfig: DialogConfig,
    // private modelService: ModalService
    private modalService: SmartModalService,
  ) {
  }

  ngOnInit(): void {
    this.data = this.dialogConfig;
  }

  copyToClipboard(value: string): void {
    navigator.clipboard.writeText(value).then(() => {
      this.modalService.close({
        success: true,
        message: 'Copied to clipboard successfully!'
      });
    }).catch(err => {
      console.error("Failed to copy: ", err);
    });
  }


}
